
import { PropType } from 'vue'

export default {
  props: {
    reverse: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  }
}
